"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ticket = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Ticket = function Ticket(_a) {
  var id = _a.id;
  var clipPathId = id ? "Ticket__clip0__".concat(id) : 'Ticket__clip0';
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("g", {
    clipPath: "url(#".concat(clipPathId, ")")
  }, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.896 6.671l.756.755c.222.223.347.524.348.838v1.413a1.196 1.196 0 01-.348.838L10.536 23.654a1.201 1.201 0 01-.84.347H8.28a1.201 1.201 0 01-.84-.347l-.756-.755a1.196 1.196 0 01-.312-1.341c.155-.38.233-.787.228-1.198a2.997 2.997 0 00-3-2.994 3.091 3.091 0 00-1.2.228 1.202 1.202 0 01-1.296-.311l-.756-.755A1.196 1.196 0 010 15.69v-1.413c.001-.314.126-.615.348-.838L13.464.348c.223-.221.525-.346.84-.347h1.416c.308-.012.609.095.84.3l.756.754c.377.336.502.873.312 1.341-.155.38-.233.787-.228 1.198a2.997 2.997 0 003 2.993 3.09 3.09 0 001.2-.227 1.202 1.202 0 011.296.311zM9.6 11.976a2.398 2.398 0 002.4 2.396c1.325 0 2.4-1.073 2.4-2.396A2.398 2.398 0 0012 9.582a2.398 2.398 0 00-2.4 2.396z",
    clipRule: "evenodd"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: clipPathId
  }, react_1.default.createElement("path", {
    fill: "#fff",
    d: "M0 0H24V24H0z"
  }))));
};

exports.Ticket = Ticket;